;(function(){
	if (!$("body").hasClass("post-type-archive-adac_award_winners")) return;

	console.log("awardwinners.js");
	
	function matchHeight(selector) {
		var sp = $(selector).get();
		var tallest = 0;
		for (var p in sp) {
			if ($(sp[p]).height() > tallest) tallest = $(sp[p]).height();
		} 
		$(selector).height(tallest);
	}
	function killIfAllEmpty(selector) {
		var sp = $(selector).get();
		var empty = true;
		for (var p in sp) {
			if ($(sp[p]).text().trim()) empty = false;
		}
		//try {console.log("empty: " + empty);} catch (e) {};
		if (empty) $(selector).remove();
	}

	//matchHeight(".star h3");
	//matchHeight(".star h4");
	//matchHeight(".star p");
	killIfAllEmpty(".star h3");
	killIfAllEmpty(".star h4");
	killIfAllEmpty(".star p");

	var doResizingMagic = function() {
		matchHeight(".star .info");
	}

	$(window).on("load resize orientationchange", debounce(doResizingMagic, 500))
	doResizingMagic();
})();